document.addEventListener('click', (e) => {
  const btn = e.target.closest('mobile-filters-trigger .collection-filter__btn');
  if (!btn) return;

  // Theme toggelt .is-active, wir lesen danach den State
  requestAnimationFrame(() => {
    document.body.classList.toggle('filters-open', btn.classList.contains('is-active'));
  });
});

// Safety: ESC → State runter
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') document.body.classList.remove('filters-open');
});
